import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      {/* Upper Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand & Newsletter */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/0f35813a97286f31d3228ef67b80045c.png"
                alt="Smart Heatplumb Limited"
                className="h-10 w-10 object-contain"
              />
              <span className="font-serif font-bold text-lg">Smart Heatplumb</span>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Professional plumbing and heating services across Kerry, Ireland.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Plumbing Services
                </a>
              </li>
              <li>
                <Link to="/complex-heating" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Heating Installation
                </Link>
              </li>
              <li>
                <Link to="/bathroom-offers" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Bathroom Renovations
                </Link>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Heat Pump Maintenance
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/our-works" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Our Works
                </Link>
              </li>
              <li>
                <Link to="/special-offers" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Special Offers
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Testimonials
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Get In Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-accent text-lg mt-0.5"></i>
                <a href="tel:+353873719751" className="text-gray-300 hover:text-accent text-sm transition-colors">
                  +353 87 371 9751
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-accent text-lg mt-0.5"></i>
                <a href="mailto:smartheatplumb@gmail.com" className="text-gray-300 hover:text-accent text-sm transition-colors break-all">
                  smartheatplumb@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-accent text-lg mt-0.5"></i>
                <span className="text-gray-300 text-sm">
                  208 Beechcourt, Killarney<br />Co. Kerry, V93 VX49
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © 2025 Smart Heatplumb Limited. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg hover:bg-accent hover:border-accent transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg hover:bg-accent hover:border-accent transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg hover:bg-accent hover:border-accent transition-colors"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-base"></i>
              </a>
              <a
                href="https://wa.me/353873719751"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg hover:bg-accent hover:border-accent transition-colors"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base"></i>
              </a>
            </div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-accent text-sm transition-colors whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;